import { descending } from 'd3'
import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { updateView } from './update-view.js'
import { generateButtons, generateSelect } from '../../../../helpers/generic-js/menus/index.js'

export const menuOptions = {}

export function showMenu (context) {
  context.menuOptions = menuOptions

  menuOptions.optionGrouping = generateButtons({
    containerId: 'optionGrouping',
    groupLabel: 'Transactions grouped by',
    buttonOptions: [
      {
        label: 'By Month',
        value: 'byMonth'
      },
      {
        label: 'By Day',
        value: 'byDay'
      },
      {
        label: 'Not grouped (ie. Transactions list)',
        value: 'transactions'
      }
    ],
    // selected: 'transactions',
    selected: 'byMonth',
    onChange: function () {
      updateView(context, false)
    }
  })

  menuOptions.optionStatement = generateButtons({
    containerId: 'optionStatement',
    groupLabel: 'Financial Statement',
    buttonOptions: [
      {
        label: 'Profit & Loss',
        value: 'pnl'
      },
      {
        label: 'Balance Sheet',
        value: 'bs'
      },
      {
        label: 'Any',
        value: 'any'
      }
    ],
    selected: 'any',
    onChange: function () {
      updateView(context, false)
    }
  })

  const dateseries = makeDateSeries(context.browserAppAccount.data.firstLedgerDate)
  dateseries.sort((a, b) => {
    return descending(a, b)
  })
  const selectOptions = dateseries.map(function (date) {
    return {
      label: date,
      value: date
    }
  })
  // console.log(dateseries)
  // console.log('dateseries[dateseries.length - 3]', dateseries[dateseries.length - 3])

  menuOptions.optionDateFrom = generateSelect({
    containerId: 'optionDateFrom',
    selectOptions,
    selectedValue: dateseries[3],
    onChange: function () {
      updateView(context, true)
    }
  })
  menuOptions.optionDateTo = generateSelect({
    containerId: 'optionDateTo',
    selectOptions,
    selectedValue: dateseries[0],
    onChange: function () {
      updateView(context, true)
    }
  })

  menuOptions.optionMultiplier = generateButtons({
    containerId: 'optionMultiplier',
    groupLabel: 'How to show numbers?',
    buttonOptions: [
      {
        label: 'Debits positives (ie. expenses, assets)',
        value: 'debitPositive'
      },
      {
        label: 'Credits positives (ie. revenue, liabilities)',
        value: 'creditPositive'
      }
    ],
    selected: 'creditPositive',
    onChange: function () {
      updateView(context, false)
    }
  })

  const entitiesOptions = context.browserAppAccount.data.entities.map(function (entity) {
    return {
      label: entity.name,
      value: entity.id
    }
  })
  entitiesOptions.unshift({
    label: 'All',
    value: 'all'
  })

  console.log('entitiesOptions', entitiesOptions)
  menuOptions.optionEntity = generateButtons({
    containerId: 'optionEntity',
    groupLabel: 'Entities',
    buttonOptions: entitiesOptions,
    selected: 'all',
    onChange: function () {
      updateView(context, false)
    }
  })

  const currenciesOptions = context.browserAppAccount.data.currenciesForAccount.map(function (currency) {
    return {
      label: `${currency.code}: ${currency.name}`,
      value: currency.code
    }
  })
  currenciesOptions.unshift({
    label: 'Entity Currency',
    value: 'XXX'
  })

  console.log('entitiesOptions', entitiesOptions)
  menuOptions.optionCurrency = generateButtons({
    containerId: 'optionCurrency',
    groupLabel: 'Currency',
    buttonOptions: currenciesOptions,
    selected: 'XXX',
    onChange: function () {
      updateView(context, false)
    }
  })

  menuOptions.optionTransactionDebug = generateButtons({
    containerId: 'optionTransactionDebug',
    groupLabel: '[Debug] Show all transactions?',
    buttonOptions: [
      {
        label: 'Yes, including reversals',
        value: 'all'
      },
      {
        label: 'No, only impacting transactions',
        value: 'impacting'
      }
    ],
    selected: 'impacting',
    onChange: function () {
      updateView(context, false)
    }
  })
}
